import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import HelmFramework from "@/pages/HelmFramework";
import OpportunitySprint from "@/pages/OpportunitySprint";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Consultation from "@/pages/Consultation";
import ConsultationV2 from "@/pages/ConsultationV2";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CookiePolicy from "@/pages/CookiePolicy";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App" data-testid="app-root">
            <BrowserRouter>
                <Routes>
                    <Route path="/consultation" element={<Consultation />} />
                    <Route path="/consultation-v2" element={<ConsultationV2 />} />
                    <Route element={<Layout />}>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<Services />} />
                        <Route path="/helm-framework" element={<HelmFramework />} />
                        <Route path="/ai-opportunity-sprint" element={<OpportunitySprint />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#101820",
                        color: "#F7F4EF",
                        border: "1px solid #101820",
                        borderRadius: "2px",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
